const React = require('react'),
    { t } = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    mui = require('material-ui'),
    ContentUtils = require('utils/ContentUtils'),
    { delay, debounce } = require('lodash/function'),
    Loading = require('components/Commons/Loading/Loading'),
    { map, filter, includes, every } = require('lodash/collection'),
    { capitalize, toLower, trim } = require('lodash/string'),
    Pagination = require('components/Commons/Pagination/Pagination'),
    sortBy = require('lodash/collection').sortBy,
    get = require('lodash/object').get,
    AppConstants = require('constants/AppConstants'),
    TextFieldSuggested = require('components/Commons/TextField/TextFieldSuggested/TextFieldSuggested'),
    PositionUtil = require('utils/PositionUtils'),
    {
        Table,
        TableHeader,
        TableRow,
        TableHeaderColumn,
        TableBody,
        TableRowColumn,
        TextField,
        FontIcon
    } = mui;

const HeaderAppAndHeaderScaffoldingAndHeaderTable = 365,
    timeToWaitUntilFinishWriteColumnSearching = 1000;

const AdminScaffoldingTable = React.createClass({displayName: "AdminScaffoldingTable",
    propTypes: {
        children: PropTypes.array,
        headerActiveFilters: PropTypes.array,
        columnNames: PropTypes.array,
        displayAttributes: PropTypes.array,
        isRowSelected: PropTypes.bool,
        attributeId: PropTypes.string,
        onRowSelection: PropTypes.func,
        sortByColumn: PropTypes.array,
        value: PropTypes.any,
        customHeightTable: PropTypes.number,

        onTypingFilter: PropTypes.func,
        isLoading: PropTypes.bool,
        currentPage: PropTypes.number,
        maxPage: PropTypes.number,
        onNextPage: PropTypes.function,
        onPreviousPage: PropTypes.function,
        onClickPage: PropTypes.function,
        onCancel: PropTypes.function,
        columnsFilterValue: PropTypes.object,
        items: PropTypes.array
    },

    _isRowSelected(item) {
        const { value } = this.props;
        return item.id === get(value, 'id', '-1');
    },

    _lastRowScrollPosition: null,

    getInitialState() {
        return {
            filters: []
        };
    },

    _onRowSelection(onRowSelection, items, indexRowSelected) {
        const { sortByColumn } = this.props;

        if (sortByColumn) {
            items = sortBy(items, row =>
                toLower(get(row, sortByColumn, []))
            );
        }

        items = this._applyFiltersIfNeeded(items);

        // filter disable items
        items = ContentUtils.filterEnable(items);

        // delay selection row a little bit in order to give some
        // time finish the selection table animation.
        const itemSelected = items[indexRowSelected];
        const indexRowSelectedItem = get(indexRowSelected, '0');
        const _lastRowClickedPosition = this._lastRowScrollPosition;

        const filterTargets = this._getFiltersTarget();

        delay(() => {
            onRowSelection(
                itemSelected,
                indexRowSelectedItem,
                _lastRowClickedPosition,
                filterTargets
            );
        }, 50);
    },

    _onPreRowSelection(evt) {
        if (evt && evt.pageY) {
            // save temporally the last position which
            // had the table in order to return this
            // position when the consumer refresh the
            // scroll position
            const parentScroll = PositionUtil.getParentScroll(evt.target);
            this._lastRowScrollPosition = parentScroll.scrollTop;
        }
    },

    _addFilter(name, self, index) {
        // I call an imperative way because we can't get the value from the evt.target
        // because we lose them from debounce arguments
        let match = "";
        if(name !== "state" && name !== "displayPriority"){
            match = self.refs['column-filter-' + index].getValue();
        } else {
            match = self.id;
        }
        const newFilter = {
            name,
            match
        };

        /* const isEmptyFilterValue = ContentUtils.isEmptyText(match) || !match;
        if (isEmptyFilterValue) {
            this.props.onClickPage(0);
            this.props.onCancel();
        } else { */
            if (this.props.onTypingFilter) {
                this.props.onTypingFilter(newFilter.name, newFilter.match);
            }
        /* } */
    },

    _applyFiltersIfNeeded(rows) {
        const enableRows = ContentUtils.filterEnable(rows);
        const filterTarget = this._getFiltersTarget();
        const userWroteSomeFilter = !ContentUtils.isEmptyArray(filterTarget);
        const existsSomeRowToDisplay = !ContentUtils.isEmptyArray(rows);

        if (userWroteSomeFilter && existsSomeRowToDisplay) {
            return filter(enableRows, row => {
                const applySomeFilter = every(filterTarget, filter => {
                    const rowValue = get(row, filter.name, '');
                    const matcher = toLower(trim(filter.match));
                    const value = toLower(trim(rowValue));
                    return value.indexOf(matcher) > -1;
                });
                return applySomeFilter;
            });
        }

        return rows;
    },

    /**
     * Retrieve the current filter which the current user are using.
     * @return {*}
     * @private
     */
    _getFiltersTarget() {
        const { filters } = this.state;
        const { headerActiveFilters } = this.props;

        let filterTarget;
        const isInternalFilterNotDefined = !filters || filters.length == 0;

        if (isInternalFilterNotDefined) {
            filterTarget = headerActiveFilters;
        } else {
            filterTarget = filters || [];
        }

        return filterTarget;
    },

    _getHeaderColumns() {
        const {
            columnNames,
            displayAttributes,
            filteredColumns,
            columnsFilterValue,
            items
        } = this.props;

        columnsFilterValue || {};

        return map(displayAttributes, (possibleColumnField, index) => {
            const isCustomField = typeof possibleColumnField === 'object'
            const columnField = isCustomField ? possibleColumnField.name : possibleColumnField;
            const columnDisplay = get(columnNames, index, columnField);
            const columnFilterValue = columnsFilterValue[columnField];
            const isNeededFilter = includes(filteredColumns, columnField);
            const columnDisplayUpper = capitalize(columnDisplay);

            let classNameHeaderFilter = 'admin-table-header__filter';
            let classNameHeaderFilterSuggested = 'classNameHeaderFilterSuggested';
            let classNameHeaderFilterIcon = 'material-icons admin-table-header__icon';
            let classNameHeaderFilterIconClear = 'material-icons admin-table-header__iconClear';

            let itemSelected = {};
            let hasItems = false;
           

            if(items && items[columnField] !== undefined && items[columnField].length > 0){
                hasItems = true;
                items[columnField].forEach((e)=>{
                    if(columnFilterValue === e.id){
                        itemSelected = {id: e.id, state: e.state};
                    } 
                })
            }

            const self = this;
            return (
                React.createElement(TableHeaderColumn, {
                    className: "header-tank-column", 
                    style: { paddingLeft: '8px'}
                }, 
                    isNeededFilter
                        ? hasItems ? React.createElement("div", null, 
                            itemSelected.id !== undefined && React.createElement(FontIcon, {
                            className: classNameHeaderFilterIconClear, 
                            color: { color: '#e0e0e0'}, 
                            onClick: ()=> self._addFilter(columnField,{id: ""}, index)
                        }, 
                            "clear"
                        ), 
                        React.createElement(FontIcon, {
                            color: { color: '#e0e0e0'}, 
                            className: classNameHeaderFilterIcon
                        }, 
                            "search"
                        ), 
                        React.createElement(TextFieldSuggested, {
                            items: items[columnField], 
                            name: columnDisplay, 
                            readerAttribute: "state", 
                            readerAttributeValue: "id", 
                            isRequired: false, 
                            floatingLabelText: columnDisplayUpper, 
                            value: itemSelected, 
                            onItemSelected:  (e)=>
                                self._addFilter(columnField,e, index), 
                            
                            classCSS: classNameHeaderFilterSuggested, 
                            defaultValue: 
                                 itemSelected
                            }
                        )
                        
                        ) : React.createElement("div", null, 
                            React.createElement(FontIcon, {
                                color: { color: '#e0e0e0'}, 
                                className: classNameHeaderFilterIcon
                            }, 
                                "search"
                            ), 
                            React.createElement(TextField, {
                                ref: 'column-filter-' + index, 
                                onChange: 
                                    debounce(() => {
                                        self._addFilter(columnField, self, index);
                                    }, timeToWaitUntilFinishWriteColumnSearching), 
                                
                                floatingLabelText: columnDisplayUpper, 
                                className: classNameHeaderFilter, 
                                defaultValue: 
                                    ContentUtils.isEmptyText(columnFilterValue) ? '' : columnFilterValue
                                }
                            )
                        )
                        : columnDisplayUpper
                )
            );
        });
    },

    _getTableRowContent(item, attributeDisplay) {
        const haveHTMLValue = !!attributeDisplay.getHTML;
        const haveAttributeName = !!attributeDisplay.name;

        if (!haveHTMLValue) {
            return get(item, attributeDisplay.name);
        } else if (haveHTMLValue && haveAttributeName) {
            return attributeDisplay.getHTML(item, attributeDisplay.name);
        } else if (haveHTMLValue && !haveAttributeName) {
            return attributeDisplay.getHTML(item);
        } else {
            return item;
        }
    },

    _getRows(sortedChildren) {
        const { displayAttributes } = this.props;
        const self = this;

        const rowsEl = map(sortedChildren, item => {
            const columnsEl = map(displayAttributes, attributeDisplay => {
                let rowEl;
                if (typeof attributeDisplay === 'string') {
                    rowEl = (
                        React.createElement(TableRowColumn, {
                            onClickCapture: this._onPreRowSelection
                        }, 
                            get(item, attributeDisplay, '')
                        )
                    );
                } else {
                    rowEl = (
                        React.createElement(TableRowColumn, {
                            onClickCapture: this._onPreRowSelection
                        }, 
                            this._getTableRowContent(item, attributeDisplay)
                        )
                    );
                }
                return rowEl;
            });
            const isSelectedRow = self._isRowSelected(item);
            let tableRowClassName = 'admin-table-row';
            if (isSelectedRow) {
                tableRowClassName += ' is-selected';
            }

            const attributeId = (get(item, 'attributeId') || get(item, 'id'));

            return (
                React.createElement(TableRow, {
                    className: tableRowClassName, 
                    style: { cursor: 'pointer'}, 
                    selected: isSelectedRow, 
                    "data-row-id": attributeId
                }, 
                    columnsEl
                )
            );
        });

        return rowsEl;
    },

    someFilterHasSomeValue() {
        return get(map(this.props.columnsFilterValue, key => key).filter(value => value !== ''), 'length') > 0;
    },

    render() {
        const { onRowSelection, children, sortByColumn, customHeightTable, currentPage, onNextPage, onPreviousPage, maxPage, onClickPage, isLoading } = this.props;
        let sortedChildren;
        if (sortByColumn) {
            sortedChildren = sortBy(children, row =>
                toLower(get(row, sortByColumn, ''))
            );
        }

        const rowsFiltered = this._applyFiltersIfNeeded(
            sortedChildren || children
        );

        const rowsWithoutDisabledItems = filterDisabledItems(rowsFiltered);
        const rowsEl = this._getRows(rowsWithoutDisabledItems || children);
        const columnsHeaderEl = this._getHeaderColumns();
        const bodyEl = isLoading ? null : (
            React.createElement(TableBody, {
                className: "admin-table-body", 
                displayRowCheckbox: false, 
                deselectOnClickaway: false}, 
                rowsEl
            ));
        const loadingEl = isLoading ? React.createElement("div", {className: "admin-scaffolding-table__loading"}, React.createElement(Loading, null), " ") : null;
        const paginationEl = this.someFilterHasSomeValue() ? null : (
            React.createElement(Pagination, {
                currentPage: currentPage, 
                maxPage: maxPage, 
                onNextPage: onNextPage, 
                onPreviousPage: onPreviousPage, 
                onClickPage: onClickPage}
            )
        );
        return (
            React.createElement("div", {className: "admin-scaffolding-table"}, 
                React.createElement(Table, {className: "admin-table", 
                    selectable: true, 
                    fixedHeader: true, 
                    multiSelectable: false, 
                    deselectOnClickaway: false, 
                    preScanRowData: false, 
                    onRowSelection: this._onRowSelection.bind(this, onRowSelection, children)}, 
                    React.createElement(TableHeader, {
                        displayRowCheckbox: false, 
                        className: "admin-table-header", 
                        style: { backgroundColor: '#838485'}
                    }, 
                        React.createElement(TableRow, {
                            className: "admin-table-header-row", 
                            displayRowCheckbox: false
                        }, 
                            columnsHeaderEl
                        )
                    ), 
                    bodyEl
                ), 
                loadingEl, 
                React.createElement("div", {className: "admin-scaffolding-table__pagination"}, 
                    paginationEl
                )
            )
        );
    }
});

function filterDisabledItems(items) {
    // the items which dont have `enable` field for now, we take as enable.
    return filter(items, item => item.enable === undefined || item.enable === true);
}

module.exports = AdminScaffoldingTable;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTablePaged.jsx
 **/